import {createFileRoute} from '@tanstack/react-router'
import {Container, Stack, Title} from "@mantine/core";
import SizesManagement from "@components/settings/sizesManagement.tsx";
import CategoryManagement from "@components/settings/categoryManagement.tsx";
import PresetManagement from "@components/settings/presetManagement.tsx";

export const Route = createFileRoute('/_authenticated/settings')({
	component: RouteComponent,
})

function RouteComponent() {
	return (
		<Container fluid>
			<Stack gap={"xl"}>
				<Title>Nastavení</Title>
				<section id={"sizes"}>
					<Title order={2} className={"toc-item"}>Velikosti položek</Title>
					<SizesManagement/>
				</section>
				<section>
					<Title order={2} className={"toc-item"}>Druhy položek</Title>
					<CategoryManagement/>
				</section>
				<section id={"presets"}>
					<Title order={2} className={"toc-item"}>Přednastavení pro položky</Title>
					<PresetManagement/>
				</section>
			</Stack>
		</Container>
	)
}
